import { BlobType } from 'src/app/enums/blob-storage/blob-type.enum';
import { environment } from 'src/environments/environment';

export const MobileEndpoints = {
  SyncAppUser: environment.mobileApiUrl + '/Mobile/sync/app-user',
  SyncTeam: environment.mobileApiUrl + '/Mobile/sync/team/{teamId}',
  SyncProject: environment.mobileApiUrl + '/Mobile/sync/project/{projectId}',
};

export const UserEndpoints = {
  GetUser: environment.userApiUrl + '/User/{}',
  BadgePhoto: environment.userApiUrl + '/User/badge-photo',
  OrganizationLogo: environment.userApiUrl + '/User/organization-logo',
};

export const FlexFormsEndpoints = {
  SyncForms: environment.flexFormsApiUrl + '/form-definitions/sync',
  SyncChoices: environment.flexFormsApiUrl + '/choice-definitions/sync',
  UploadDocuments: environment.flexFormsApiUrl + '/documents',
};

export const BlobStorageEndpoints = {
  [BlobType.PHOTO]: environment.attachmentApiUrl + '/Attachment/GetFileUploadToken',
  [BlobType.VIDEO]: {
    read: environment.attachmentApiUrl + '/Attachment/sas-token-urls/videos/{filename}/read',
    write: environment.attachmentApiUrl + '/Attachment/sas-token-urls/videos/{filename}/write',
  },
  [BlobType.INDEXED_DB]: {
    create: environment.attachmentApiUrl + '/Attachment/sas-token-urls/indexed-db/create',
    write: environment.attachmentApiUrl + '/Attachment/sas-token-urls/indexed-db/write',
  },
  [BlobType.ODOMETER_READING]: environment.webApiBaseUrl + '/v3/odometer-reading/image/sas-token/create',
};
